// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.aging-donut-card {
  display: flex;
  align-items: center;
  gap: 32px;
  flex-wrap: wrap;
  padding: 8px 0 4px;
}

.aging-donut-ring-wrap {
  position: relative;
  flex: 0 0 auto;
  width: 120px;
  height: 120px;
}

.aging-donut-svg {
  display: block;
}

.aging-donut-segment {
  cursor: pointer;
  transition: stroke-width 0.12s ease, opacity 0.12s ease;
}

.aging-donut-empty-ring {
  stroke: var(--an-border);
}

.aging-donut-hole {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 68px;
  height: 68px;
  border-radius: 50%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  pointer-events: none;
}

.aging-donut-total-value {
  font-size: 16px;
  font-weight: 700;
  letter-spacing: -0.01em;
  color: var(--an-text);
  line-height: 1.2;
}

.aging-donut-total-label {
  font-size: 10.5px;
  color: var(--an-text-faint);
  margin-top: 2px;
  white-space: nowrap;
}

.aging-donut-legend {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 8px;
  min-width: 200px;
  flex: 1 1;
}

.aging-donut-legend-row {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 13px;
  padding: 3px 6px;
  border-radius: 6px;
  cursor: pointer;
  transition: background 0.12s ease;
}

.aging-donut-legend-row-active {
  background: var(--an-surface-hover);
}

.aging-donut-legend-swatch {
  width: 10px;
  height: 10px;
  border-radius: 2px;
  flex: 0 0 auto;
}

.aging-donut-legend-label {
  flex: 1 1;
  color: var(--an-text-muted);
}

.aging-donut-legend-amount {
  font-weight: 700;
  color: var(--an-text);
  font-variant-numeric: tabular-nums;
}

.aging-donut-legend-pct {
  flex: 0 0 40px;
  text-align: right;
  color: var(--an-text-faint);
  font-size: 12px;
  font-variant-numeric: tabular-nums;
}
`, "",{"version":3,"sources":["webpack://./src/Components/Analytics/charts/AgingDonut.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,uDAAuD;AACzD;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,2BAA2B;EAC3B,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;EAChB,SAAO;AACT;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,kCAAkC;AACpC;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,2BAA2B;EAC3B,eAAe;EACf,kCAAkC;AACpC","sourcesContent":[".aging-donut-card {\n  display: flex;\n  align-items: center;\n  gap: 32px;\n  flex-wrap: wrap;\n  padding: 8px 0 4px;\n}\n\n.aging-donut-ring-wrap {\n  position: relative;\n  flex: 0 0 auto;\n  width: 120px;\n  height: 120px;\n}\n\n.aging-donut-svg {\n  display: block;\n}\n\n.aging-donut-segment {\n  cursor: pointer;\n  transition: stroke-width 0.12s ease, opacity 0.12s ease;\n}\n\n.aging-donut-empty-ring {\n  stroke: var(--an-border);\n}\n\n.aging-donut-hole {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  width: 68px;\n  height: 68px;\n  border-radius: 50%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  pointer-events: none;\n}\n\n.aging-donut-total-value {\n  font-size: 16px;\n  font-weight: 700;\n  letter-spacing: -0.01em;\n  color: var(--an-text);\n  line-height: 1.2;\n}\n\n.aging-donut-total-label {\n  font-size: 10.5px;\n  color: var(--an-text-faint);\n  margin-top: 2px;\n  white-space: nowrap;\n}\n\n.aging-donut-legend {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  min-width: 200px;\n  flex: 1;\n}\n\n.aging-donut-legend-row {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  font-size: 13px;\n  padding: 3px 6px;\n  border-radius: 6px;\n  cursor: pointer;\n  transition: background 0.12s ease;\n}\n\n.aging-donut-legend-row-active {\n  background: var(--an-surface-hover);\n}\n\n.aging-donut-legend-swatch {\n  width: 10px;\n  height: 10px;\n  border-radius: 2px;\n  flex: 0 0 auto;\n}\n\n.aging-donut-legend-label {\n  flex: 1;\n  color: var(--an-text-muted);\n}\n\n.aging-donut-legend-amount {\n  font-weight: 700;\n  color: var(--an-text);\n  font-variant-numeric: tabular-nums;\n}\n\n.aging-donut-legend-pct {\n  flex: 0 0 40px;\n  text-align: right;\n  color: var(--an-text-faint);\n  font-size: 12px;\n  font-variant-numeric: tabular-nums;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
